/**
 * 证书查询指引（09 帮助中心的子页）
 * -----------------------------------------------------------------------------
 * 口径（`01-页面清单与路由.md` §4.3、边界 C-12）：
 *   - 只提供**发证机关官方渠道的查询指引**
 *   - **不提供**证书下载、不生成证书、不提供站外跳转通道
 * 因此本页只有文字步骤，没有外链按钮、没有下载入口。
 */
import { Card, Notice, PageShell } from '../components/layout';

const STEPS = [
  '打开浏览器，访问发证机关（职业技能鉴定机构）官网',
  '在官网找到「证书查询」栏目',
  '输入本人姓名与身份证号，按官网提示完成查询',
  '如需核验证书真伪，以官网查询结果为准',
] as const;

const FAQ = [
  '考试结束后需要等待成绩发布与制证周期，尚未到发证时间时查不到属正常现象',
  '查询不到时，请先核对姓名与身份证号是否与报名信息完全一致',
  '如仍有疑问，请通过「联系客服」与我们确认',
] as const;

export default function CertificateHelp() {
  return (
    <PageShell title="证书查询指引" back>
      <Notice tone="info">证书由发证机关颁发并管理，本系统不提供证书下载。</Notice>

      <Card title="查询步骤" tight>
        <ol className="num-steps">
          {STEPS.map((text, index) => (
            <li key={text} className="num-steps__item">
              <span className="num-steps__no">{index + 1}</span>
              <span>{text}</span>
            </li>
          ))}
        </ol>
      </Card>

      <Card title="常见问题" tight>
        <ul className="bullet-list">
          {FAQ.map((text) => (
            <li key={text} className="bullet-list__item">
              <span className="bullet-list__dot" />
              <span>{text}</span>
            </li>
          ))}
        </ul>
      </Card>
    </PageShell>
  );
}
